var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopWCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 56,
    viewBox: "0 0 232 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.85 39.875C135.759 39.8605 155.191 45.4838 171.515 55.9833H231.801C218.837 38.7116 201.518 24.5951 181.332 14.8444C161.145 5.09376 138.693 0 115.901 0C93.1083 0 70.6561 5.09376 50.4696 14.8444C30.2831 24.5951 12.9648 38.7116 0 55.9833H60.2864C76.5825 45.5019 95.9765 39.8794 115.85 39.875Z",
    fill: "#FFBC78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopWCurve);
export default __webpack_public_path__ + "static/media/top-w-curve.1a345f32a8dd9f92c61ffed43e40947a.svg";
export { ForwardRef as ReactComponent };